var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWreath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75.7 59",
    style: {
      enableBackground: "new 0 0 75.7 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:url(#SVGID_21_);}\n\t.st21{fill:url(#SVGID_22_);}\n\t.st22{fill:url(#SVGID_23_);}\n\t.st23{fill:url(#SVGID_24_);}\n\t.st24{fill:url(#SVGID_25_);}\n\t.st25{fill:url(#SVGID_26_);}\n\t.st26{fill:url(#SVGID_27_);}\n\t.st27{fill:url(#SVGID_28_);}\n\t.st28{fill:url(#SVGID_29_);}\n\t.st29{fill:url(#SVGID_30_);}\n\t.st30{fill:url(#SVGID_31_);}\n\t.st31{fill:url(#SVGID_32_);}\n\t.st32{fill:url(#SVGID_33_);}\n\t.st33{fill:url(#SVGID_34_);}\n\t.st34{fill:url(#SVGID_35_);}\n\t.st35{fill:url(#SVGID_36_);}\n\t.st36{fill:url(#SVGID_37_);}\n\t.st37{fill:url(#SVGID_38_);}\n\t.st38{fill:url(#SVGID_39_);}\n\t.st39{fill:url(#SVGID_40_);}\n\t.st40{fill:url(#SVGID_41_);}\n\t.st41{fill:url(#SVGID_42_);}\n\t.st42{fill:url(#SVGID_43_);}\n\t.st43{fill:url(#SVGID_44_);}\n\t.st44{fill:url(#SVGID_45_);}\n\t.st45{fill:url(#SVGID_46_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.7529,
    y1: 33.6777,
    x2: 42.5753,
    y2: 33.6777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,8.5c-6,14.6-2.9,28.4,10.6,36.8c1.9,1.1,3.8,2.1,5.6,3c5.2,2.5,10.5,4.3,14.4,6.5c2,1.1,3.6,2.3,5,4.1 l0.3-0.2c-1.4-1.8-3.1-3-5.1-4.2c-4-2.2-9.2-4-14.5-6.5c-1.9-0.9-3.8-1.9-5.6-3C4,36.8,0.9,23,6.8,8.5L6.7,8.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.7311,
    y1: 48.0961,
    x2: 32.8017,
    y2: 48.0961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,44.5c0.5,0.4,1.4,0.9,2.3,1.6c2.9,2.4,3,4.1,2.7,5.6C30.6,50.1,28,49.5,27.7,44.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.9158,
    y1: 46.0358,
    x2: 27.5754,
    y2: 46.0358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.9,42.5c2.4,1.8,5.1,4.1,4.6,7c-0.3-0.2-1-0.6-1.8-1.2c-0.8-0.6-1.5-1.3-1.9-2 C23.2,45.3,22.9,44,22.9,42.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.4101,
    y1: 43.7707,
    x2: 22.5034,
    y2: 43.7707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.5,40.2c2.4,2.2,4.4,4.5,3.9,7.1C20,45.7,17.9,44,18.5,40.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3123,
    y1: 41.0819,
    x2: 17.6879,
    y2: 41.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.7,37.5c2.2,2.8,3.4,5.1,2.9,7.2C15,42.8,13.6,40.5,14.7,37.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.7737,
    y1: 37.805,
    x2: 13.3632,
    y2: 37.805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M11.6,34.1c1.1,2.1,2.3,5.1,1.5,7.4C10.4,38.7,10.3,36.1,11.6,34.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9237,
    y1: 33.8344,
    x2: 9.985,
    y2: 33.8344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M9.3,30.1c0.6,2.3,1.1,5.3,0,7.4C7.7,35,7.2,32.2,9.3,30.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.9431,
    y1: 29.2084,
    x2: 8.0033,
    y2: 29.2084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M7.9,25.6C8.2,27.8,8,31,6.6,32.8C5.1,28.9,6.4,26.6,7.9,25.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.7261,
    y1: 24.1775,
    x2: 7.4205,
    y2: 24.1775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.4,20.7c0,0.5-0.1,1.2-0.3,2c-0.3,1.7-1,3.7-2.3,4.9C4.2,23.5,5.8,21.5,7.4,20.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.279,
    y1: 18.9534,
    x2: 7.8141,
    y2: 18.9534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.8,15.8c-0.3,1.5-1.3,4.7-3.5,6.4C4.4,18,6.2,16.2,7.8,15.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.7053,
    y1: 13.7147,
    x2: 9,
    y2: 13.7147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M9,10.8c-0.6,2-2,4.4-4.3,5.9C5.2,14.1,6.4,11.1,9,10.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.0159,
    y1: 8.6,
    x2: 10.8699,
    y2: 8.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M10.9,5.9c-0.8,2-2.3,4-4.9,5.3C6.5,10,7.8,6,10.9,5.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.0696,
    y1: 3.8769,
    x2: 11.3128,
    y2: 3.8769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M11.3,0c-0.7,2.1-2.4,6.6-4.2,7.8C6.9,5.7,8,2.7,11.3,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.1487,
    y1: 53.5285,
    x2: 31.8571,
    y2: 53.5285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M23.1,54.2c0.7,0.2,1.7,0.5,2.9,0.6c3.8,0.4,5-0.8,5.8-1.9c-0.5-0.1-3.3-1-5.1-0.5 C25.6,52.6,24.4,53.3,23.1,54.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.3015,
    y1: 50.8672,
    x2: 26.185,
    y2: 50.8672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M17.3,51.1c0.7,0.2,1.7,0.6,2.9,0.9c1.2,0.2,2.5,0.3,3.8,0c0.8-0.2,1.5-0.6,2.2-1.6c-0.3,0-1.1-0.3-2-0.5 c-1-0.2-2.1-0.4-3-0.3C19.9,49.8,18.6,50.3,17.3,51.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.582,
    y1: 47.7547,
    x2: 20.5615,
    y2: 47.7547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M11.6,47.2c0.6,0.4,1.6,0.9,2.8,1.3c3.6,1.2,5.2,0.3,6.2-0.8c-0.5-0.1-3.2-1.3-4.9-1.3 C14.4,46.4,13.1,46.7,11.6,47.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.4587,
    y1: 43.7132,
    x2: 15.2054,
    y2: 43.7132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M6.5,42.1C7,42.6,7.9,43.4,8.9,44c3.2,1.9,5,1.4,6.3,0.4C12.9,43.5,12.1,41.9,6.5,42.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.6125,
    y1: 38.2793,
    x2: 10.4441,
    y2: 38.2793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2.6,35.9c1.7,2.9,4.7,5.9,7.8,4.5C8,38.5,8.1,37.3,2.6,35.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.5009,
    y1: 32.1359,
    x2: 6.7435,
    y2: 32.1359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M0.5,29c0.2,0.7,0.5,1.7,1.1,2.8c1.7,3.1,3.5,3.7,5.1,3.6C4.9,33,5.5,31.8,0.5,29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 25.6702,
    x2: 4.4505,
    y2: 25.6702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M0,21.9c0.2,3.2,1.3,6.9,4.5,7.5C3.3,26.9,4.1,25.8,0,21.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.7663,
    y1: 19.1392,
    x2: 3.5596,
    y2: 19.1392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M0.9,15.1c-0.4,3.2-0.2,6.8,2.6,8.2C3.1,20.4,3.9,19.5,0.9,15.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.2461,
    y1: 12.7986,
    x2: 4.3199,
    y2: 12.7986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M3,8.6c-1,2.9-1.4,6.4,1,8.4C4.1,14.4,5.1,13.4,3,8.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.4866,
    y1: 6.7941,
    x2: 6.5391,
    y2: 6.7941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M6,2.6c-1.4,2.7-2.4,5.9-0.5,8.3C6.1,8.3,7.2,7.9,6,2.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8922,
    y1: 33.7569,
    x2: 72.5304,
    y2: 33.7569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M69.3,8.6c6.5,15.8,2.8,30.6-16,39.5c-1.9,0.9-3.7,1.7-5.5,2.4c-6.6,2.8-11.3,4.7-14,8.3l0.3,0.2 c2.8-3.7,8.4-5.9,13.8-8.2c1.7-0.7,3.6-1.5,5.5-2.4c18.7-9,22.8-23.7,16.1-39.9L69.3,8.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.1806,
    y1: 53.6323,
    x2: 52.8777,
    y2: 53.6323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M52.9,54.3c-0.7,0.2-1.7,0.4-2.9,0.6c-1.2,0.1-2.5,0.1-3.7-0.2c-0.8-0.2-1.5-0.7-2.1-1.7 c0.3,0,1.1-0.3,2.1-0.5c1-0.2,2.1-0.3,3-0.1C50.5,52.7,51.7,53.4,52.9,54.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.289,
    y1: 51.2333,
    x2: 58.0757,
    y2: 51.2333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M58.1,51.5c-2,0.7-4.3,1.3-6.5,0.8c-0.8-0.2-1.6-0.7-2.3-1.6c0.4-0.1,1.2-0.3,2.1-0.5 C53,49.9,55,49.6,58.1,51.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3799,
    y1: 48.4946,
    x2: 63.1997,
    y2: 48.4946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M63.2,48.2c-2.8,1.5-6.7,2.6-8.8,0.2c0.6-0.2,2.1-0.8,3.4-1C59.6,47,61.6,47.4,63.2,48.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.3012,
    y1: 45.0852,
    x2: 67.9485,
    y2: 45.0852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M67.9,43.9c-2.4,2-6.3,3.6-8.6,1.7C61,44.8,64.1,43,67.9,43.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.8391,
    y1: 40.6949,
    x2: 71.8563,
    y2: 40.6949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M71.9,38.7c-1.9,2.5-5.3,4.9-8,3.5C65.3,41.2,68.2,38.7,71.9,38.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.6836,
    y1: 35.4798,
    x2: 74.4749,
    y2: 35.4798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M74.5,32.8c-1.1,2.7-3.9,5.8-6.8,5.3C68.8,36.8,71.2,33.5,74.5,32.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.4964,
    y1: 29.894,
    x2: 75.7182,
    y2: 29.894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M75.7,26.6c-0.3,2.2-2.1,6.2-5.2,6.5C71.3,31.6,72.8,27.9,75.7,26.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.1365,
    y1: 24.083,
    x2: 75.7339,
    y2: 24.083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M75.7,20.4c0.1,2.7-1,6.3-3.6,7.4C72.5,26.3,73.2,22.1,75.7,20.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.6517,
    y1: 18.2808,
    x2: 74.8984,
    y2: 18.2808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M74.6,14.4c0.6,2.5,0.2,6-2,7.7C72.7,20.8,72.5,16.5,74.6,14.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.6524,
    y1: 12.6621,
    x2: 73.4204,
    y2: 12.6621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M72.7,8.8c1,2.1,1.2,5.5-0.6,7.8C71.9,14.8,71,11,72.7,8.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.4418,
    y1: 7.3246,
    x2: 71.3521,
    y2: 7.3246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M70,3.5c1.2,1.8,2,4.7,0.7,7.6C70.2,9.5,68.6,5.9,70,3.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.7331,
    y1: 3.9893,
    x2: 69.1745,
    y2: 3.9893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M64.7,0.2c3.2,2.1,4.7,6.1,4.4,7.6C66.6,5.7,65.2,1.3,64.7,0.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.7705,
    y1: 47.9859,
    x2: 48.8072,
    y2: 47.9859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M48.8,44.4c-2.8,1.9-5.7,4-4.9,7.2C45.9,50,48.6,49.4,48.8,44.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.5072,
    y1: 45.6387,
    x2: 54.1041,
    y2: 45.6387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M54.1,42.1c-2.8,2.2-5.1,4.2-4.5,7.1c0.2-0.2,0.9-0.6,1.7-1.2C53,46.8,54.2,45.4,54.1,42.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.0526,
    y1: 42.9976,
    x2: 58.9665,
    y2: 42.9976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M58.8,39.4c-2.4,2.5-4.3,4.4-3.7,7.3c0.2-0.2,0.9-0.6,1.6-1.2C58.3,44.1,59.4,42.6,58.8,39.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.1717,
    y1: 39.7882,
    x2: 63.298,
    y2: 39.7882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M62.8,36c-2,3.2-3.1,5-2.3,7.5C61.8,42.1,64.4,40.5,62.8,36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.4635,
    y1: 35.8131,
    x2: 66.9255,
    y2: 35.8131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M65.7,32c-1.3,3.9-1.7,5.6-0.6,7.7c0.1-0.1,0.2-0.3,0.4-0.6c0.2-0.3,0.4-0.6,0.6-1 C67.2,36.2,67.4,34.4,65.7,32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.3536,
    y1: 30.9918,
    x2: 69.587,
    y2: 30.9918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M67.6,27.2c-0.2,2-0.7,5,0.6,7c0.1,0.2,0.3,0.4,0.4,0.6c0.1-0.3,1.2-2.7,0.8-4.4 C69.2,29.2,68.6,28.2,67.6,27.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.3758,
    y1: 25.5684,
    x2: 71.1921,
    y2: 25.5684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M68.4,21.9c0.3,3.4,0.6,5.6,2.6,7.3c0-0.1,0.1-0.4,0.1-0.7c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.3c0-0.9,0-1.9-0.4-2.6C70.3,23.7,69.5,22.7,68.4,21.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.0473,
    y1: 19.8468,
    x2: 71.8884,
    y2: 19.8468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M68,16.5c0.2,0.8,0.9,3.8,2.3,5.4c0.1,0.1,0.3,0.3,0.4,0.4c0.3,0.3,0.7,0.6,1.2,0.8 C71.7,21.4,72.1,18.6,68,16.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.7286,
    y1: 14.0793,
    x2: 71.5489,
    y2: 14.0793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M66.7,11c1.2,2.8,2.3,5.1,4.8,6.1C71,15.3,71,12.7,66.7,11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.5681,
    y1: 8.4639,
    x2: 70.1063,
    y2: 8.4639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDC18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1915D"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M64.6,5.8c1.6,2.8,2.9,4.7,5.5,5.4C69.3,9.3,68.9,7,64.6,5.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWreath);
export default __webpack_public_path__ + "static/media/wreath.0f2a7255a6df729568d7379a23fefa0b.svg";
export { ForwardRef as ReactComponent };